import { useEffect } from 'react';
import { useHistory } from 'react-router';
import { useFormikContext } from 'formik';
import _isEmpty from 'lodash/isEmpty';

const HandleRedirect = () => {
  const { dirty, resetForm, errors } = useFormikContext();
  const history = useHistory();

  useEffect(() => {
    resetForm();
  }, [history.location.pathname]);

  useEffect(() => {
    function handleCloseTab(event: any) {
      if (dirty || !_isEmpty(errors)) {
        event.preventDefault();
        event.returnValue = '';
      }
    }
    window.addEventListener('beforeunload', handleCloseTab);
    return () => window.removeEventListener('beforeunload', handleCloseTab);
  }, [dirty, errors]);
  return null;
};

export default HandleRedirect;
